'use client';

import { Box, Typography } from '@mui/material';

import { formatCurrency } from '@/utils';

interface ProfitLossStatsProps {
  totalPnL: number;
  subtitle: string;
}

export const ProfitLossStats = ({ totalPnL, subtitle }: ProfitLossStatsProps) => {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="h4"
        fontWeight={700}
        sx={{
          mb: 0.1,
          letterSpacing: '-0.02em',
          fontSize: '1.5rem',
          color: 'text.primary',
        }}
      >
        {formatCurrency(totalPnL)}
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
        {subtitle}
      </Typography>
    </Box>
  );
};
